import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import styles from './CardIcon.module.scss';

const CardIcon = (props) => {
  const {
    card_number,
    brand,
    bank_name,
    account_number,
    showTooltip = false,
    classes = '',
  } = props;

  const renderCardContent = () => {
    if (brand && card_number)
      return (
        <>
          <Grid item className={styles.cardIconContainer}>
            <img
              className={clsx(styles.cardImage, styles.cardIcon)}
              src={`/images/credit-card-icons/${brand}.svg`}
              alt={brand}
            />
          </Grid>

          <Grid item className={styles.cardTextContainer}>
            <Typography variant="body2" className={styles.cardText}>
              {brand.charAt(0).toUpperCase() + brand.slice(1)} ****{' '}
              {card_number}
            </Typography>
          </Grid>
        </>
      );
    else if (bank_name && account_number) {
      return (
        <>
          <Grid item>
            <AccountBalanceIcon className={styles.bankImage} fontSize="large" />
          </Grid>
          <Grid item className={clsx(styles.achCard, 'ml-10')}>
            <Typography variant="body2">{bank_name}</Typography>

            <Typography variant="body2">
              **** **** **** {account_number}
            </Typography>
          </Grid>
        </>
      );
    }

    return '-';
  };

  if (!(card_number || bank_name)) return <></>;

  return (
    <Tooltip title="Default card on file" disableHoverListener={!showTooltip}>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        wrap="nowrap"
        className={clsx(styles.cardContainer, classes, 'ml-10', {
          [styles.achContainer]: bank_name && account_number,
        })}
      >
        {renderCardContent()}
      </Grid>
    </Tooltip>
  );
};

CardIcon.propTypes = {
  card_number: PropTypes.string,
  brand: PropTypes.string,
  bank_name: PropTypes.string,
  account_number: PropTypes.string,
  showTooltip: PropTypes.bool,
  classes: PropTypes.string,
};

export default CardIcon;
